import { FC, useCallback, useState, MouseEvent } from 'react'
import { Box, IconButton } from '@mui/material'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import Help from '@mui/icons-material/Help'
import clsx from 'clsx'
import { Modal } from '@dxp-module/common'
import clickableModalTooltipStyles from './clickableModalTooltip.styles'

type CustomClickableTooltipProps = {
  useOutlineIcon?: boolean
  className?: string
  children?: string | JSX.Element | JSX.Element[]
  isHeader?: boolean
}

const ClickableModalTooltip: FC<CustomClickableTooltipProps> = ({
  children,
  useOutlineIcon = false,
  className = '',
  isHeader,
}) => {
  const styles = clickableModalTooltipStyles()
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const IconTagName = useOutlineIcon ? InfoOutlined : Help

  const openTooltip = useCallback((e: MouseEvent) => {
    e.stopPropagation()
    setTooltipOpen(true)
  }, [])

  return (
    <Box component="span" className={className} data-test="tooltip:icon">
      <IconButton
        onClick={openTooltip}
        data-test="common:mui:tooltip"
        className={styles.tooltipIconButton}
        disableRipple={true}
      >
        <IconTagName color="primary" viewBox="0 0 28 28" fontSize="small" />
      </IconButton>
      {tooltipOpen && (
        <Modal open={tooltipOpen} onClose={() => setTooltipOpen(false)}>
          <Box
            className={clsx([
              styles.contentContainer,
              !isHeader && styles.contentMargin,
            ])}
          >
            {children}
          </Box>
        </Modal>
      )}
    </Box>
  )
}

export default ClickableModalTooltip
